import ReactDOM from "react-dom";
import React, { useState, useRef, useEffect } from "react";
import "../styles/ContextMenu.css";
import { getGlobalState } from "../utils/globalState";
import { faTrash, faFolderPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContextMenu = ({
  x,
  y,
  onDeleteDashboard,
  nodeType,
  nodeId,
  handleAddNewFolderClick,
  handleDeleteFolder,
  contextMenu,
}) => {
  const { myFolderId } = getGlobalState();
  const [addingFolder, setAddingFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (addingFolder && inputRef.current) {
      inputRef.current.focus();
    }
  }, [addingFolder]);

  const handleAddFolderClick = () => {
    setAddingFolder(true);
  };

  const handleAddFolder = () => {
    setAddingFolder(false);
    handleAddNewFolderClick(nodeId, newFolderName);
    setNewFolderName("");
    contextMenu.visible = false;
  };

  const handleDeleteClick = () => {
    handleDeleteFolder(nodeId);
    contextMenu.visible = false;
  };

  const menu = (
    <div
      data-context-menu
      onMouseDown={(e) => e.stopPropagation()}
      className="context-menu bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden"
      style={{ top: y, left: x }}
    >
      <ul className="py-1 divide-y divide-gray-100">
        {nodeType === "dashboard" && (
          <li
            className="px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer flex items-center"
            onClick={onDeleteDashboard}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-2" /> Delete Dashboard
          </li>
        )}
        {nodeType === "folder" && nodeId !== "f_" + myFolderId && (
          <li
            className="px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer flex items-center"
            onClick={handleDeleteClick}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-2" /> Delete Folder
          </li>
        )}
        {nodeType === "folder" && !addingFolder && (
          <li
            onClick={handleAddFolderClick}
            className="px-4 py-2 text-sm text-blue-600 hover:bg-blue-50 cursor-pointer flex items-center"
          >
            <FontAwesomeIcon icon={faFolderPlus} className="mr-2" />
            Add Folder
          </li>
        )}
      </ul>
      {addingFolder && (
        <div className="p-3 bg-gray-50 border-t border-gray-200">
          <div className="flex items-center space-x-2">
            <input
              type="text"
              ref={inputRef}
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Folder Name"
            />
            <button onClick={handleAddFolder} className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Add</button>
          </div>
        </div>
      )}
    </div>
  );
  return ReactDOM.createPortal(menu, document.body);
};

export default ContextMenu;
